import { call, put, takeLatest } from "redux-saga/effects";
import CoberturaActions, { Types } from "../../stores/cobertura/Actions";
import CoberturaService from "../../services/cobertura/CoberturaService";
import ResponseCode from "../../services/ResponseCode";

function* obtenerDatosPss(request) {
  yield put(CoberturaActions.obtenerDatosPssLoading());

  const { datosPSS } = request.payload;

  const obtenerDatosPssResponse = yield call(
    CoberturaService.obtenerDatosPss,
    datosPSS
  );

  if (
    !obtenerDatosPssResponse?.respuesta ||
    obtenerDatosPssResponse?.respuesta?.codigo ===
      ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerDatosPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (
    !obtenerDatosPssResponse?.respuesta ||
    obtenerDatosPssResponse?.respuesta?.codigo === ResponseCode.NOT_FOUND.code
  ) {
    yield put(
      CoberturaActions.obtenerDatosPssFailure({
        codigo: ResponseCode.NOT_FOUND.code,
        mensaje: ResponseCode.NOT_FOUND.message
      })
    );
    return;
  }

  const procedimientosResponse = yield call(
    CoberturaService.obtenerTipoCoberturaContratadaPss,
    datosPSS
  );

  if (
    !procedimientosResponse?.respuesta ||
    procedimientosResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerDatosPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (
    !procedimientosResponse?.respuesta ||
    procedimientosResponse?.respuesta?.codigo === ResponseCode.NOT_FOUND.code
  ) {
    yield put(
      CoberturaActions.obtenerDatosPssFailure({
        codigo: ResponseCode.NOT_FOUND.code,
        mensaje: ResponseCode.NOT_FOUND.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.obtenerDatosPssSuccess({
      prestador: obtenerDatosPssResponse?.data,
      procedimientos: procedimientosResponse?.data.registros ?? []
    })
  );
}

function* obtenerCoberturasPss(request) {
  yield put(CoberturaActions.obtenerCoberturaContratadaPssLoading());

  const { datosPSS } = request.payload;

  const response = yield call(
    CoberturaService.obtenerCoberturaContratadaPss,
    datosPSS
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerCoberturaContratadaPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  const coberturas = response?.data || [];

  const paginacionData = {
    coberturas,
    totalRegistros: response?.totalRegistros || 0,
    numeroPagina: response?.numeroPagina || 1,
    tamanoPagina: response?.tamanoPagina || 20,
    totalPaginas: response?.totalPaginas || 0
  };

  yield put(
    CoberturaActions.obtenerCoberturaContratadaPssSuccess(paginacionData)
  );
}

function* guardarCoberturasPss(request) {
  yield put(CoberturaActions.guardarCoberturaContratadaPssLoading());

  const { tipoPss, codigoPss, coberturas } = request.payload;

  const response = yield call(CoberturaService.guardarCoberturaContratadaPss, {
    tipoPss,
    codigoPss,
    coberturas
  });

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.guardarCoberturaContratadaPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.guardarCoberturaContratadaPssSuccess(response?.data)
  );
}

function* obtenerTiposCoberturas(request) {
  yield put(CoberturaActions.obtenerTipoCoberturasLoading());

  const response = yield call(CoberturaService.obtenerTiposCoberturas);

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerTipoCoberturasFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.obtenerTipoCoberturasSuccess(
      response?.data?.registros ?? []
    )
  );
}

function* obtenerCoberturas(request) {
  yield put(CoberturaActions.obtenerCoberturasLoading());

  const { tipoCobertura, cobertura } = request.payload;

  const response = yield call(CoberturaService.obtenerCoberturas, {
    tipoCobertura,
    cobertura
  });

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerCoberturasFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.obtenerCoberturasSuccess(response?.data?.registros ?? [])
  );
}

function* obtenerCoberturaDocumentos(request) {
  yield put(CoberturaActions.obtenerCoberturaDocumentosLoading());

  const { tipoProcedimiento, cobertura } = request.payload;

  const response = yield call(CoberturaService.obtenerCoberturaDocumentos, {
    tipoProcedimiento,
    cobertura
  });

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerCoberturaDocumentosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.obtenerCoberturaDocumentosSuccess(response?.data ?? [])
  );
}

function* guardarCoberturaDocumentos(request) {
  yield put(CoberturaActions.guardarCoberturaDocumentosLoading());

  const { tipoProcedimiento, compania, cobertura, documentos } =
    request.payload;

  const response = yield call(CoberturaService.guardarCoberturaDocumentos, {
    tipoProcedimiento,
    compania,
    cobertura,
    documentos
  });

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.guardarCoberturaDocumentosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.guardarCoberturaDocumentosSuccess({
      data: response?.data,
      mensaje: response?.respuesta?.mensaje
    })
  );
}

function* obtenerCoberturasConfiguradasPss(request) {
  yield put(CoberturaActions.obtenerCoberturasConfiguradasPssLoading());

  const response = yield call(
    CoberturaService.obtenerCoberturasConfiguradasPss
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerCoberturasConfiguradasPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.obtenerCoberturasConfiguradasPssSuccess(
      response?.data ?? []
    )
  );
}

function* obtenerCoberturasConfiguradasDocumentos(request) {
  yield put(CoberturaActions.obtenerCoberturasConfiguradasDocumentosLoading());

  const { tipoProcedimiento, cobertura } = request.payload;

  const response = yield call(
    CoberturaService.obtenerCoberturasConfiguradasDocumentos,
    {
      tipoProcedimiento,
      cobertura
    }
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      CoberturaActions.obtenerCoberturasConfiguradasDocumentosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    CoberturaActions.obtenerCoberturasConfiguradasDocumentosSuccess(
      response?.data ?? []
    )
  );
}

const exportedArray = [
  takeLatest(Types.OBTENER_DATOS_PSS, obtenerDatosPss),
  takeLatest(Types.OBTENER_COBERTURA_CONTRATADA_PSS, obtenerCoberturasPss),
  takeLatest(Types.GUARDAR_COBERTURA_CONTRATADA_PSS, guardarCoberturasPss),
  takeLatest(Types.OBTENER_TIPO_COBERTURAS, obtenerTiposCoberturas),
  takeLatest(Types.OBTENER_COBERTURAS, obtenerCoberturas),
  takeLatest(Types.OBTENER_COBERTURA_DOCUMENTOS, obtenerCoberturaDocumentos),
  takeLatest(Types.GUARDAR_COBERTURA_DOCUMENTOS, guardarCoberturaDocumentos),
  takeLatest(
    Types.OBTENER_COBERTURAS_CONFIGURADAS_PSS,
    obtenerCoberturasConfiguradasPss
  ),
  takeLatest(
    Types.OBTENER_COBERTURAS_CONFIGURADAS_DOCUMENTOS,
    obtenerCoberturasConfiguradasDocumentos
  )
];

export default exportedArray;
